import React from 'react';

import { useConversionTable } from 'hooks';
import { useCXI } from 'modules/cxi/useCXI';

import { Option } from '../components/option/Option';

import * as Form from '../components/form';

export const Trends = () => {
    const { t, vars, addVars } = useCXI();
    const conv = useConversionTable(['trend']);
    const data = vars.profile.profile.sector.trends;

    const handleChange = value => {
        let newData = [...data];
        if (data.includes(value)) {
            newData = data.filter(v => v !== value);
        } else {
            newData.push(value);
        }

        const profile = {
            ...vars.profile,
            profile: {
                ...vars.profile.profile,
                sector: { ...vars.profile.profile.sector, trends: [...newData] },
            },
        };
        addVars({ profile });
    };

    return (
        <Form.Form name="Trends">
            <Form.Title>{t('setup.Titles.trends')}</Form.Title>
            <Form.Descr>{t('setup.Descrs.trends')}</Form.Descr>
            <Form.Small>{t('setup.Smalls.trends')}</Form.Small>

            <Form.OptionsContainer>
                {Object.keys(conv.trend)
                    .map(value => parseInt(value, 10))
                    .map(value => (
                        <Option
                            label={conv.trend[String(value)]}
                            value={value}
                            key={value}
                            checked={!!data.includes(value)}
                            onChange={() => handleChange(value)}
                        />
                    ))}
            </Form.OptionsContainer>
        </Form.Form>
    );
};
